import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { getPrivacyPolicyLink } from '../utils';

export const PrivacyPolicyAgency = () => {
    const { t } = useTranslation('PayseraRecruitmentBundle');

    return (
        <Trans
            t={t}
            i18nKey="apply_form.privacy_policy_agency"
            values={{ privacy_policy: t('apply_form.privacy_policy') }}
            components={[
                <a target="blank" rel="noreferrer" href={getPrivacyPolicyLink()}>{t('apply_form.privacy_policy')}</a>
            ]}
        />
    );
};
